//@ts-ignore
import { ApiClient } from "lib/ApiClient";
import { useGenericSWR } from "lib/useGenericSWR";

const apiEndpoint = 'api/v1/admin/uc/UserAccessStats';

let formIteration = 0;

const getUserAccessStatsDefaultItem = () => {
    formIteration = formIteration + 1;
    return {
        formIteration: "new" + formIteration,
        id: 0,
        userId: 0,
    }
};

// See definition from UsageRate.cs
const apiClient = new ApiClient();
apiClient.getDefaultItem = () => getUserAccessStatsDefaultItem();
apiClient.getObjectName = () => {
    return "User Access Stats";
};

const useUserAccessStat = (id: number, swrOptions = {}) => {
    // SWR will prevent duplicate requests
    // It will also maintain data state as long as your are using the same urls for your requests
    return useGenericSWR(apiEndpoint + "/" + id, apiClient, { ...swrOptions });
};

const useUserAccessStats = (filter: any, swrOptions = {}) => {
    // SWR will prevent duplicate requests
    // It will also maintain data state as long as your are using the same urls for your requests
    const params = new URLSearchParams();
    params.append('filter', JSON.stringify(filter));
    return useGenericSWR(apiEndpoint + "?" + params.toString(), apiClient, { ...swrOptions });
};

export {
    useUserAccessStat,
    useUserAccessStats,
    getUserAccessStatsDefaultItem
};